import { gql } from "@apollo/client";

export const GET_COMPANIES_QUERY = gql`
  query getCompany($id: ID!, $company: ID) {
    getCompany(id: $id) {
      id
      name
      internalReference
      accountingFirm {
        id
        name
      }
      software {
        name
        apiUrl
        id
        software {
          value
        }
        importExportAuto
      }
      fiscal {
        declareTva
      }
      settings {
        accountingType {
          label
          value
        }
      }
    }
    listCyclesPaginated(filter: { company: $company, isActive: true }) {
      totalCount
      results {
        id
        startDate
        endDate
        limitDate
        expenseClaimCounterpart {
          id
          name
          code
        }
        incomeInPersonalBankAccountCounterpart {
          id
          name
          code
        }
        expenseInCashCounterpart {
          id
          name
          code
        }
        incomeInCashCounterpart {
          id
          name
          code
        }
        defaultVatCounterpart {
          id
          name
          code
        }
      }
    }
    getCurrentCycle(company: $id) {
      id
    }
  }
`;

export const LIST_COUNTERPARTS = gql`
  query listCounterpartsPaginated($filter: CounterPartFilter, $limit: Int, $offset: Int) {
    listCounterpartsPaginated(filter: $filter) {
      totalCount
      results(limit: $limit, offset: $offset) {
        id
        name
        code
      }
    }
  }
`;

export const GET_ACCOUNTING_FIRM = gql`
  query ($accountingFirmId: ID!) {
    getAccountingFirm(id: $accountingFirmId) {
      id
      name
      companies {
        id
      }
    }
  }
`;

export const GET_COUNTERPARTS_SETTINGS_OPTIONS = gql`
  query listCounterpartsSettingsOptions(
    $search: String
    $companyId: ID
    $cycleId: ID
    $limit: Int
    $offset: Int
  ) {
    listCounterpartsPaginated(
      filter: { search: $search, companyId: $companyId, cycleId_In: [$cycleId], isActive: true }
    ) {
      results(limit: $limit, offset: $offset) {
        id
        name
        code
      }
    }
  }
`;

export const UPDATE_CYCLE_SETTINGS = gql`
  mutation updateCycle($input: UpdateCycleInput!) {
    updateCycle(input: $input) {
      success
      errors {
        field
        messages
      }
      cycle {
        id
        startDate
        endDate
        limitDate
        expenseClaimCounterpart {
          id
          name
          code
        }
        incomeInPersonalBankAccountCounterpart {
          id
          name
          code
        }
        expenseInCashCounterpart {
          id
          name
          code
        }
        incomeInCashCounterpart {
          id
          name
          code
        }
        defaultVatCounterpart {
          id
          name
          code
        }
      }
    }
  }
`;
